import _objectSpread from "/Users/beixinyuan/Documents/www/newParty1/party-pc/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import _asyncToGenerator from "/Users/beixinyuan/Documents/www/newParty1/party-pc/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.number.to-fixed.js";
import "core-js/modules/es.math.trunc.js";
import { defineComponent, toRefs, reactive, ref, computed } from "vue";
import useCurrentInstance from "@/hooks/useCurrentInstance";
import { Loading } from "@element-plus/icons";
import Head from "@/components/Head/index.vue";
import { useRouter } from "vue-router";
import { ArrowRight } from "@element-plus/icons";
import { ElMessage } from "element-plus";
import 'element-plus/es/components/message/style/index'

export default defineComponent({
  name: "",
  components: {
    Head: Head,
    Loading: Loading,
    ArrowRight: ArrowRight
  },
  setup: function setup() {
    var router = useRouter();

    var _useCurrentInstance = useCurrentInstance(),
        globalProperties = _useCurrentInstance.globalProperties;

    var loading = ref(false); // 图片路径前缀

    var baseUrl = process.env.VUE_APP_BASE_URL;
    var PaginationInit = ref(false); // 数据列表信息

    var dataList = reactive({
      listData: [],
      totalNum: 0,
      obj: {
        type: 1,
        category: 2,
        pageIndex: 1,
        pageSize: 10
      }
    });
    getTabledata();

    function getTabledata() {
      return _getTabledata.apply(this, arguments);
    } // 翻页


    function _getTabledata() {
      _getTabledata = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var res;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                loading.value = false;
                _context.next = 3;
                return globalProperties === null || globalProperties === void 0 ? void 0 : globalProperties.$api["getLrbList"](dataList.obj);

              case 3:
                res = _context.sent;

                if (res.code == 0) {
                  dataList.listData = res.data;
                  loading.value = true;
                }

              case 5:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));
      return _getTabledata.apply(this, arguments);
    }

    function changPage(_x) {
      return _changPage.apply(this, arguments);
    } //计算进度


    function _changPage() {
      _changPage = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(val) {
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                dataList.obj.pageIndex = val;
                getTabledata();

              case 2:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));
      return _changPage.apply(this, arguments);
    }

    var percent = computed(function () {
      return function (row) {
        if (!row.userNews.studyTime) {
          return 0;
        } else {
          return Number(((row.studyDuration - row.userNews.studyTime) / row.studyDuration).toFixed(2)) * 100;
        }
      };
    }); //取消收藏

    function handleCollect(_x2) {
      return _handleCollect.apply(this, arguments);
    } //计算时长


    function _handleCollect() {
      _handleCollect = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(id) {
        var res;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return globalProperties === null || globalProperties === void 0 ? void 0 : globalProperties.$api["studyDeleteCollect"](id);

              case 2:
                res = _context3.sent;

                if (res.code == 0) {
                  ElMessage.success("取消收藏成功");
                  getTabledata();
                } else {
                  ElMessage.success(res.msg);
                }

              case 4:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }));
      return _handleCollect.apply(this, arguments);
    }

    function secTotime(s) {
      var t = "";

      if (s > -1) {
        var min = Math.floor(s / 60);
        var sec = Math.trunc(s % 60);

        if (min < 10) {
          t += "0";
        }

        t += min + ":";

        if (sec < 10) {
          t += "0";
        }

        t += sec.toFixed(0);
      }

      return t;
    } //计算学时


    var conversion = computed(function () {
      return function (seconds, studyDuration) {
        if (!seconds) {
          return 0;
        } else {
          return ((studyDuration - seconds) / 60).toFixed(2);
        }
      };
    }); // 跳转详情页

    function toPage(newsId) {
      router.push({
        name: "StudyDetail",
        query: {
          newsId: newsId
        }
      });
    } // 返回


    function back() {
      router.back();
    }

    return _objectSpread(_objectSpread({
      loading: loading,
      PaginationInit: PaginationInit,
      changPage: changPage
    }, toRefs(dataList)), {}, {
      toPage: toPage,
      back: back,
      baseUrl: baseUrl,
      handleCollect: handleCollect,
      percent: percent,
      secTotime: secTotime,
      conversion: conversion
    });
  }
});